<div mat-dialog-title>Size Guide (in inches)</div>

<div mat-dialog-content>
  <table mat-table [dataSource]="values">
    @for (title of titles; track $index) {
    <ng-container [matColumnDef]="title">
      <th mat-header-cell *matHeaderCellDef>{{title}}</th>
      <td mat-cell *matCellDef="let element">{{element[$index]}}</td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="titles"></tr>
    <tr mat-row *matRowDef="let row; columns: titles;"></tr>
  </table>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>
